// test777
(777 && 0);
